(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-chart-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var host = document.getElementById('size-chart-dialog');
    if (!host) return;

    var cells = host.querySelectorAll('td[data-in]');
    var EIGHTHS = { 0: '', 1: '⅛', 2: '¼', 3: '⅜', 4: '½', 5: '⅝', 6: '¾', 7: '⅞' };

    function inches(n) {
      var whole = Math.floor(n);
      var eighths = Math.round((n - whole) * 8);
      if (eighths === 8) { whole += 1; eighths = 0; }
      if (eighths === 0) return String(whole);
      return (whole ? whole + ' ' : '') + EIGHTHS[eighths];
    }

    function render(unit) {
      cells.forEach(function (td) {
        var n = parseFloat(td.getAttribute('data-in'));
        if (!isFinite(n)) return;
        td.textContent = unit === 'cm' ? String(Math.round(n * 2.54 * 2) / 2) : inches(n);
      });
      host.querySelectorAll('.size-chart__unit').forEach(function (b) {
        var on = b.getAttribute('data-unit') === unit;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      try { localStorage.setItem('rr-size-unit', unit); } catch (e) {}
    }

    host.addEventListener('click', function (e) {
      var b = e.target.closest('.size-chart__unit');
      if (b) render(b.getAttribute('data-unit'));
    });

    var saved = 'in';
    try { saved = localStorage.getItem('rr-size-unit') || 'in'; } catch (e) {}
    render(saved === 'cm' ? 'cm' : 'in');
  })();
  } catch(e) { console.error(e); }
})();

})();
